<template>
    <BaseComponent :title="configuracion.title">
        <div class="col-md-6 col-sm-12" :class="!footer.renovar_abono ? 'disabled' : ''" v-if="!footer.ocultar_renovar_abono"> 
            <router-link
                v-if="footer.renovar_abono"
                :to="{ name: 'front.abonos.renovar.index' }"
            >
                
                <div class="thumb-container absolute " :style='"background-image: url(" + footer.bg1_url + ")"'></div>
                <span>
                    {{ teatro.hash === 'oKJlTbCtFDANXL6JMNUp' ? $t('home.renovar_bcb') : $t('home.renovar', {abono : teatro.texto_abono}) }}
                </span>
                
            </router-link>

            <a href="#" v-else>
                <div class="thumb-container absolute " :style='"background-image: url(" + footer.bg1_url + ")"'></div>
                <span><del>{{ teatro.hash === 'oKJlTbCtFDANXL6JMNUp' ? $t('home.renovar_bcb') : $t('home.renovar', {abono : teatro.texto_abono}) }}</del></span>
            </a>
        </div>
        <div class="col-md-6 col-sm-12" :class="!footer.nuevo_abono ? 'disabled' : ''" v-if="!footer.ocultar_abonos">
            <router-link 
                v-if="footer.nuevo_abono"
                :to="{ name: 'front.abonos.nuevo.index' }"
            >
                <div class="thumb-container absolute " :style='"background-image: url(" + footer.bg1_url + ")"'></div>
                <span>{{ etiquetaNuevoAbono }}</span>
            </router-link>

            <a href="#" v-else>
                <div class="thumb-container absolute " :style='"background-image: url(" + footer.bg1_url + ")"'></div>
                <span><del>{{ etiquetaNuevoAbono }}</del></span>
            </a>
        </div>
        <div class="col-md-6 col-sm-12" :class="!footer.venta_simpatizantes ? 'disabled' : ''" v-if="!esUcamEventos && !footer.ocultar_simpatizantes">
            <router-link
                v-if="footer.venta_simpatizantes"
                :to="{ name: 'front.simpatizantes.index' }"
            >
                <div class="thumb-container absolute " :style='"background-image: url(" + footer.bg1_url + ")"'></div>
                <span>{{ configuracion.simpatizantes?.charAt(0).toUpperCase() + configuracion.simpatizantes?.slice(1) }}</span>
            </router-link>

            <a href="#" v-else>
                <div class="thumb-container absolute " :style='"background-image: url(" + footer.bg1_url + ")"'></div>
                <span><del>{{ configuracion.simpatizantes?.charAt(0).toUpperCase() + configuracion.simpatizantes?.slice(1) }}</del></span>
            </a>

        </div>
        <div class="col-md-6 col-sm-12" :class="!footer.partidos ? 'disabled' : ''" v-if="!footer.ocultar_eventos">
            <router-link
                v-if="footer.partidos"
                :to="{ name: 'front.eventos.index' }"
            >
                <div class="thumb-container absolute " :style='"background-image: url(" + footer.bg1_url + ")"'></div>
                <span>{{ $t('home.partidos') }}</span>
            </router-link>
            <a href="#" v-else>
                <div class="thumb-container absolute " :style='"background-image: url(" + footer.bg1_url + ")"'></div>
                <span><del>{{ $t('home.partidos') }}</del></span>
            </a>
        </div>
        <div class="col-md-6 col-sm-12" :class="!footer.activar_experiencias ? 'disabled' : ''" v-if="!footer.ocultar_experiencias">
            <router-link
                v-if="footer.activar_experiencias"
                :to="{ name: 'front.experiencias.index' }"
            >
                <div class="thumb-container absolute " :style='"background-image: url(" + footer.bg1_url + ")"'></div>
                <span>{{ esUcamEventos ? $t('home.eventos') : (teatro.hash != 'UHmERrsRV19JCGQMg7Is' ? textosTeatro.t('home.experiencias') : 'FUTSAL FEST') }}</span>
            </router-link>
            <a href="#" v-else-if="!footer.activar_experiencias">
                <div class="thumb-container absolute " :style='"background-image: url(" + footer.bg1_url + ")"'></div>
                <span><del>{{ esUcamEventos ? $t('home.eventos') : (teatro.hash != 'UHmERrsRV19JCGQMg7Is' ? textosTeatro.t('home.experiencias') : 'FUTSAL FEST') }}</del></span>
            </a>
        </div>
        <div class="col-md-6 col-sm-12" :class="!footer.activar_productos ? 'disabled' : ''" v-if="!footer.ocultar_productos">
            <router-link
                v-if="footer.activar_productos"
                :to="{ name: 'front.productos.index' }"
            >
                <div class="thumb-container absolute " :style='"background-image: url(" + footer.bg1_url + ")"'></div>
                <span>{{ $t('productos.productos') }}</span>
            </router-link>
            <a href="#" v-else>
                <div class="thumb-container absolute " :style='"background-image: url(" + footer.bg1_url + ")"'></div>
                <span><del>{{ $t('productos.productos') }}</del></span>
            </a>
        </div>
        <div class="col-md-6 col-sm-12" v-if="!footer.ocultar_futbol_base || !footer.ocultar_renovacion_futbol_base">
            <router-link :to="{ name: 'front.bases.index' }">
                <div class="thumb-container absolute " :style='"background-image: url(" + footer.bg1_url + ")"'></div>
                <span>{{ $t('home.cantera') }}</span>
            </router-link>
        </div>
        <div class="col-md-6 col-sm-12" :class="!footer.activar_acreditaciones ? 'disabled' : ''" v-if="!footer.ocultar_acreditaciones">
            <router-link
                v-if="footer.activar_acreditaciones"
                :to="{ name: 'front.acreditacion' }"
            >
                <div class="thumb-container absolute " :style='"background-image: url(" + footer.bg1_url + ")"'></div>
                <span>{{ $t('home.acreditacion') }}</span>
            </router-link>
            <a href="#" v-else>
                <div class="thumb-container absolute " :style='"background-image: url(" + footer.bg1_url + ")"'></div>
                <span><del>{{ $t('home.acreditacion') }}</del></span>
            </a>
        </div>
        <div class="col-md-6 col-sm-12" :class="!footer.activar_parcelas ? 'disabled' : ''" v-if="!footer.ocultar_parcelas && lista.activar_parcelas">
            <router-link
                v-if="footer.activar_parcelas"
                :to="{ name: 'front.parcelas' }"
            >
                <div class="thumb-container absolute " :style='"background-image: url(" + footer.bg1_url + ")"'></div>
                <span>{{ $t('home.parcelas') }}</span>
            </router-link>
            <a href="#" v-else>
                <div class="thumb-container absolute " :style='"background-image: url(" + footer.bg1_url + ")"'></div>
                <span><del>{{ $t('home.parcelas') }}</del></span>
            </a>
        </div>
    </BaseComponent>
</template>

<script>
    import BaseComponent from '@/components/frontend/home/BaseComponent';
    import { useTextosTeatro } from '@/composables/common/useTextosTeatro';
    import { TEATROS_UCAM_EVENTOS } from '@/constants/teatros';
    import { TEATRO_HASH_LA_MAR_DE_MUSICAS } from '@/constants/teatros';
    
    export default {        
        components: {
            BaseComponent
        },
        computed: {
            /**
             * Rótulo de "nuevo abono": manda el botón configurado; si no,
             * La Mar de Músicas tiene el suyo, Talavera el suyo y el resto el
             * genérico con el nombre que cada teatro da al abono.
             */
            etiquetaNuevoAbono() {
                // Primero los textos propios de cada teatro: si uno quiere el
                // suyo, no debe quedar tapado por el botón de la lista.
                if (this.teatro?.hash === TEATRO_HASH_LA_MAR_DE_MUSICAS) {
                    return this.$t('home.nuevo_abono_lamardemusicas');
                }

                if (this.teatro?.hash === '8IuCwC47T9n0qgn2ky0G') {
                    return this.$t('home.nuevo_abono_talavera', { abono: this.teatro?.texto_abono.toUpperCase() });
                }

                // Penúltimo: el botón que el teatro haya configurado en su lista.
                if (this.lista?.btn_nuevo_abono) {
                    return this.lista.btn_nuevo_abono;
                }

                return this.$t('home.nuevo_abono', { abono: this.teatro?.texto_abono });
            },
            textosTeatro() {
                return useTextosTeatro(this.$i18n, this.teatro?.hash);
            },
            esUcamEventos() {
                return TEATROS_UCAM_EVENTOS.includes(this.teatro?.hash);
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            footer() {
                return this.$store.getters.getFooter;
            },
            lista(){
                return this.$store.getters.getListaAbonados;
            },
            teatro(){
                return this.$store.getters.getTeatro
            }
        }
    }
</script>
